<div [class]="containerClasses()">
  <input
    class="time-input w-full bg-transparent focus:outline-none"
    [placeholder]="placeholder()"
    [value]="displayValue()"
    [disabled]="isDisabled()"
    (input)="onTimeInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />
  <button
    type="button"
    (click)="togglePeriod()"
    [disabled]="isDisabled()"
    [class]="periodButtonClasses()"
  >
    <app-text [class]="periodTextClasses()">{{ period() }}</app-text>
  </button>

  <!-- <button
    (click)="clear()"
    [disabled]="isDisabled()"
    class="clear-btn cursor-pointer -m-2 ml-2 mr-0 p-1 rounded-full border-1 border-border focus:outline-none"
  >
    <lucide-icon name="x" class="clear-btn-icn h-3 w-3"></lucide-icon>
  </button> -->
</div>
